import {
  GridRow,
  Labels,
  OptimizelyEditProperty,
  GridPresetWideContent,
  GridPresetOneHalf,
  LinkHeroFrontpage,
} from "/App.Components";
import { HeroFrontpageProps } from "/Models/Generated/HeroFrontpageProps";
import "./HeroFrontpageMinimum.scss";

const HeroFrontpageMinimum = ({
  labels,
  heading,
  headingPropertyName,
  leadText,
  leadTextPropertyName,
  readMoreLink,
  readMoreLinkPropertyName,
}: HeroFrontpageProps) => (
  <div className="hero-frontpage-minimum-norad">
    <GridRow>
      {labels && (
        <GridPresetWideContent>
          <div className="hero-frontpage-minimum-norad__tags">
            <Labels {...labels} />
          </div>
        </GridPresetWideContent>
      )}
      <GridPresetOneHalf>
        <OptimizelyEditProperty propertyName={headingPropertyName}>
          {heading && (
            <h2 className="hero-frontpage-minimum-norad__heading">{heading}</h2>
          )}
        </OptimizelyEditProperty>
      </GridPresetOneHalf>
      <GridPresetOneHalf>
        <OptimizelyEditProperty propertyName={leadTextPropertyName}>
          {leadText && (
            <p className="hero-frontpage-minimum-norad__lead-text">
              {leadText}
            </p>
          )}
        </OptimizelyEditProperty>
        <OptimizelyEditProperty propertyName={readMoreLinkPropertyName}>
          <div className="hero-frontpage-minimum-norad__link-container">
            {readMoreLink && <LinkHeroFrontpage {...readMoreLink} />}
          </div>
        </OptimizelyEditProperty>
      </GridPresetOneHalf>
    </GridRow>
  </div>
);

export default HeroFrontpageMinimum;
